import instance from '@apis/instance';
import {
    GetNotificationsParams,
    NotificationRow,
    UnreadResponse,
} from '@models/notification';
import { SliceResponse } from '@models/page';

class NotificationApi {
    static getNotifications(params: GetNotificationsParams): Promise<SliceResponse<NotificationRow>> {
        return instance.get('/v0/notifications', { params });
    }

    static getHasUnread(): Promise<UnreadResponse> {
        return instance.get('/v0/notifications/unread/exists');
    }

    static readAll(): Promise<never> {
        return instance.put('/v0/notifications');
    }

    static read(notificationId: string): Promise<never> {
        return instance.put(`/v0/notification/${notificationId}`);
    }
}

export default NotificationApi;
